export default __webpack_public_path__ + "static/media/bg.cfc556dc.jpg";